export enum R_SsoRoutes {
  SsoOld_TokenNo_TokenRefNo = "/sso/old",
}
export enum R_LoginRoutes {
  login = "/login",
  maximumOtpAttempt = "/maximumOtpAttempt",
  policyAndConditions = "/policy-&-conditions",
}
export enum R_SecondaryChannelRoutes {
  fromSecondaryChannel = "/channel",
}
export enum R_PseudoLoginRoutes {
  fromPseudoLogin = "/pseudoLogin",
}
export enum R_GeneralElementsRoutes {
  setMpin = "/set-mpin",
  search = "/search",
  notifications = "/notifications",
  biometric_setup = "/biometricSetup",
  appTracker = "/appTracker",
  taxCenter = "/taxCenter",
}
export enum R_HomeRoutes {
  home = "/home",
}
export enum R_LiRoutes {
  li_baseUrl = "/details/li",
  details_PolicyNumber = "/details/li",
  details_PolicyNumber_TaxCertificate = "/details/li/tax-certificate",
  details_PolicyNumber_PolicyAccountStatement = "/details/li/policy-account-statement",
  details_PolicyNumber_PremiumReceipts = "/details/li/premium-receipts",
  addUpdate_nominee = "/details/li/add-update-nominee",
  details_PolicyNumber_UpdatePAN = "/details/li/update-PAN",
  detail_PolicyNumber_AddUpdateBankAccount = "/details/li/addUpdate-bankAccount",
  details_set_alerts = "/details/li/set-alerts",
  details_payment = "/details/li/payment",
  details_update_profile = "/details/li/update-profile",
  details_policy_services = "/details/li/policy-services",
  details_download_statements = "/details/li/download-statements",
  li_UrlNotFound = "li/not-found",
  li_PanAadharLinking = "/li/pan-aadhar-linking",
}
export enum R_HiRoutes {
  hi_baseUrl = "/details/hi",
  edit_hi_policy_details = "/details/hi/edit",
  details_PolicyNumber_EditPolicy = "/details/hi/edit-policy",
  details_PolicyNumber = "/details/hi",
  details_PolicyNumber_MedicalReports = "/details/hi/medical-reports",
  details_PolicyNumber_PolicyDocuments = "/details/hi/policy-documents",
}
export enum R_MfRoutes {
  mutualFund_BaseUrl = "/mutual-fund",
  mutualFund_Details = "/mutual-fund/details",
  mutualFund_Transact = "/mutual-fund/transact",
  mutualFund_MyStatements = "/mutual-fund/my-statements",
  mutualFund_CapitalGains = "/mutual-fund/capital-gains",
  mutualFund_AccountStatement = "/mutual-fund/account-statement",
  mutualFund_ExitLoad = "/mutual-fund/exit-load-statement",
  mutualFund_SchemaFundDetails = "/mutual-fund/details/schema-fund-details",
}
export enum R_SSRoutes {
  details_baseUrl = "/my-portfolio",
  details_Portfolio = "/my-portfolio",
  details_Portfolio_MyDocuments = "/my-portfolio/my-documents",
  account_statement = "/my-portfolio/my-documents/account_statement",
  contact_notes = "/my-portfolio/my-documents/contacts-notes",
}
export enum R_HLRoutes {
  home_loan_baseUrl = "/details/hl",
  home_loan_details = "/details/hl",
  interest_certificate = "/details/hl/interest-certificate",
  account_statement = "/details/hl/account-statement",
  change_enach = "/details/hl/register-change-e-nach",
  document_upload = "/details/hl/document-upload",
  emi_payment = "/details/hl/emi-payment",
  disbursement_request = "/details/hl/disbursement-request",
  home_loan_service_request = "/details/hl/service-request",
  change_address = "/details/hl/change-address",
  excess_emi_refund = "/details/hl/excess-emi-refund",
  home_loan_change_mobile = "/details/hl/change-mobile",
  home_loan_change_emi_tenure = "/details/hl/change_emi_tenure",
  home_loan_change_emi_tenure_charges = "/details/hl/change_emi_tenure/charges",
  home_loan_change_emi_tenure_option3 = "/details/hl/change_emi_tenure/moreOption",
  home_loan_change_emi_date = "/details/hl/change-emi-date",
  home_loan_tds_request = "/details/hl/tds-refund",
  home_loan_change_email = "/details/hl/change-email",
  balance_confirmation_letter = "/details/hl/balance-confirmation-letter",
  change_emi_select_date = "/details/hl/change-emi-select-date",
  change_emi_upload_doc = "/details/hl/change-emi-upload-doc",
  advance_emi_payment = "/details/hl/advance-emi-payment",
  home_loan_roi_history = "/hl/roi-history",
  statement_and_document = "/details/hl/statement-and-document",
  post_disbursement_document = "/details/hl/post-disbursement-document",
  re_kyc = "/details/hl/re-kyc",
}

export enum R_ABCDRoutes {
  viewAll_transaction = "/transaction-details",
}

/** Routes that use the HLL3 revamp desktop split-panel layout */
export const R_HFL_L3_RouteList: string[] = [
  R_HLRoutes.statement_and_document,
  R_HLRoutes.home_loan_change_email,
  R_HLRoutes.account_statement,
  R_HLRoutes.balance_confirmation_letter,
  R_HLRoutes.interest_certificate,
  R_HLRoutes.advance_emi_payment,
  R_HLRoutes.change_address,
  R_HLRoutes.excess_emi_refund,
  R_HLRoutes.home_loan_tds_request,
  R_HLRoutes.home_loan_change_emi_date,
  R_HLRoutes.change_emi_select_date,
  R_HLRoutes.change_emi_upload_doc,
  R_HLRoutes.home_loan_change_emi_tenure,
  R_HLRoutes.home_loan_change_emi_tenure_charges,
  R_HLRoutes.home_loan_change_emi_tenure_option3,
  R_HLRoutes.change_enach,
  R_HLRoutes.home_loan_change_email,
  R_HLRoutes.home_loan_change_mobile,
  R_HLRoutes.home_loan_roi_history,
  R_HLRoutes.disbursement_request,
  R_HLRoutes.post_disbursement_document,
  R_HLRoutes.emi_payment,
  R_HLRoutes.re_kyc,
];

/** Returns true if the given pathname is an HLL3 revamp route */
export const R_HFL_L3_Routes = (pathname: string): boolean =>
  R_HFL_L3_RouteList.includes(pathname);

export const R_MF_L3_RouteList: string[] = [
  R_MfRoutes.mutualFund_Transact,
  R_MfRoutes.mutualFund_MyStatements,
  R_MfRoutes.mutualFund_SchemaFundDetails,
];

export const R_MF_L3_Routes = (pathname: string): boolean =>
  R_MF_L3_RouteList.includes(pathname);

export const R_HI_L3_RouteList: string[] = [
  R_HiRoutes.details_PolicyNumber_PolicyDocuments,
];

export const R_HI_L3_Routes = (pathname: string): boolean =>
  R_HI_L3_RouteList.includes(pathname);

export const R_LI_L3_RouteList: string[] = [
  R_LiRoutes.details_payment,
  R_LiRoutes.details_update_profile,
  R_LiRoutes.details_policy_services,
  R_LiRoutes.details_download_statements,
];

export const R_LI_L3_Routes = (pathname: string): boolean =>
  R_LI_L3_RouteList.includes(pathname);
